import React from "react";
import { Modal, Table, Spin } from "antd";
import moment from "moment";
import Bridge from "../../constants/Bridge";
import Strings from "../../constants/Strings";

class ViewEalsFrs extends React.Component {
  // state list
  constructor(props) {
    super(props);
    this.state = {
      status: false,
      modalLoader: false,
      modalStatus: false,
      list: [],
      selectedOption: "",
      graphdata: [],
      paginationNum: 10,
      loading: false,
      options: [
        {
          name: "Speech",
          value: "speech",
        },
        {
          name: "Salvation",
          value: "salvation",
        },
        {
          name: "Swallowing",
          value: "swallowing",
        },
        {
          name: "Hand Writing",
          value: "handwriting",
        },
        {
          name: "Cutting Food A",
          value: "cutting_food_a",
        },
        {
          name: "Cutting Food B",
          value: "cutting_food_b",
        },
        {
          name: "Dressing And Hygiene",
          value: "dressing_and_hygiene",
        },
        {
          name: "Walking",
          value: "walking",
        },
        {
          name: "Climbing Stairs",
          value: "climbing_stairs",
        },
        {
          name: "Dyspnea",
          value: "dyspnea",
        },
        {
          name: "Orthopnea",
          value: "orthopnea",
        },
        {
          name: "Respiratory Insufficiency",
          value: "respiratory_insufficiency",
        },
      ],
    };
  }
  // on load component function
  componentDidMount() {}
  // on change table pagination
  handleTableChange = (pagination, filters, sorter) => {
    this.setState({ paginationNum: pagination.pageSize });
  };
  // show modal
  showDetailsModal = () => {
    let item = this.props.item;
    this.setState({ modalLoader: true }, () =>
      this.getNotesForParticipant(item)
    );
  };
  // get als frs for participant
  getNotesForParticipant = (item) => {
    let participant_id = item.participants_id;
    let url = `?participant_id=${participant_id}&participants_accounts_id=${item.participants_accounts_id}`;
    Bridge.participants
      .get_eals_frs_list(url)
      .then((response) => {
        if (response.status == "1") {
          let arr = [];
          for (let item of response.data) {
            let cutting_food = item.cutting_food_a
              ? item.cutting_food_a
                ? item.cutting_food_a
                : 0
              : item.cutting_food_b
              ? item.cutting_food_b
              : 0;
            let total =
              Number(cutting_food) +
              Number(item.speech) +
              Number(item.salvation) +
              Number(item.swallowing) +
              Number(item.handwriting) +
              Number(item.dressing_and_hygiene) +
              Number(item.turning_in_bed) +
              Number(item.walking) +
              Number(item.climbing_stairs) +
              Number(item.dyspnea) +
              Number(item.orthopnea) +
              Number(item.respiratory_insufficiency);
            item.total = total;
            arr.push(item);
          }
          this.setState({
            list: arr,
            modalLoader: false,
            modalStatus: true,
          });
        } else {
          this.setState({
            modalLoader: false,
            modalStatus: true,
            list: [],
          });
        }
      })
      .catch(function (error) {});
  };
  // sloe details modal
  hideDetailsModal = () => {
    this.setState({ modalStatus: false });
  };
  // on change option
  handleChange = (value) => {
    this.setState({ selectedOption: value });
    if (value) {
      let arr = [];
      let obj = {};
      for (let item of this.state.list) {
        if (value == "speech") {
          obj = {
            date: moment(item.created_at).format("MM/DD/YYYY"),
            value: item.speech ? Number(item.speech) : 0,
          };
          arr = [...arr, obj];
        } else if (value == "salvation") {
          obj = {
            date: moment(item.created_at).format("MM/DD/YYYY"),
            value: item.salvation ? Number(item.salvation) : 0,
          };
          arr = [...arr, obj];
        } else if (value == "swallowing") {
          obj = {
            date: moment(item.created_at).format("MM/DD/YYYY"),
            value: item.swallowing ? Number(item.swallowing) : 0,
          };
          arr = [...arr, obj];
        } else if (value == "handwriting") {
          obj = {
            date: moment(item.created_at).format("MM/DD/YYYY"),
            value: item.handwriting ? Number(item.handwriting) : 0,
          };
          arr = [...arr, obj];
        } else if (value == "cutting_food_a") {
          obj = {
            date: moment(item.created_at).format("MM/DD/YYYY"),
            value: item.cutting_food_a ? Number(item.cutting_food_a) : 0,
          };
          arr = [...arr, obj];
        } else if (value == "cutting_food_b") {
          obj = {
            date: moment(item.created_at).format("MM/DD/YYYY"),
            value: item.cutting_food_b ? Number(item.cutting_food_b) : 0,
          };
          arr = [...arr, obj];
        } else if (value == "dressing_and_hygiene") {
          obj = {
            date: moment(item.created_at).format("MM/DD/YYYY"),
            value: item.dressing_and_hygiene
              ? Number(item.dressing_and_hygiene)
              : 0,
          };
          arr = [...arr, obj];
        } else if (value == "walking") {
          obj = {
            date: moment(item.created_at).format("MM/DD/YYYY"),
            value: item.walking ? Number(item.walking) : 0,
          };
          arr = [...arr, obj];
        } else if (value == "climbing_stairs") {
          obj = {
            date: moment(item.created_at).format("MM/DD/YYYY"),
            value: item.climbing_stairs ? Number(item.climbing_stairs) : 0,
          };
          arr = [...arr, obj];
        } else if (value == "dyspnea") {
          obj = {
            date: moment(item.created_at).format("MM/DD/YYYY"),
            value: item.dyspnea ? Number(item.dyspnea) : 0,
          };
          arr = [...arr, obj];
        } else if (value == "orthopnea") {
          obj = {
            date: moment(item.created_at).format("MM/DD/YYYY"),
            value: item.orthopnea ? Number(item.orthopnea) : 0,
          };
          arr = [...arr, obj];
        } else if (value == "respiratory_insufficiency") {
          obj = {
            date: moment(item.created_at).format("MM/DD/YYYY"),
            value: item.respiratory_insufficiency
              ? Number(item.respiratory_insufficiency)
              : 0,
          };
          arr = [...arr, obj];
        }
      }
      this.setState({ graphdata: arr });
    }
  };
  render() {
    const dataSource =
      this.state.list &&
      this.state.list.map((item, index) => {
        return {
          key: index,
          date: item.created_at
            ? moment(item.created_at).format("MM/DD/YYYY")
            : "---",
          speech: item,
          salvation: item,
          swallowing: item,
          handwriting: item,
          cutting_food: item,
          dressing_hygine: item,
          turning_in_bed: item,
          walking: item,
          climbing_stairs: item,
          dyspnea: item,
          orthopnea: item,
          respiratory: item,
          total: item.total,
        };
      });
    const Columns = [
      {
        title: "Date",
        dataIndex: "date",
        key: "date",
        width: 120,
        fixed: window.innerWidth > 650 ? "left" : false,
      },
      {
        title: "Speech",
        dataIndex: "speech",
        key: "speech",
        render: (item) => {
          let colorName = "zero_color";
          if (item.speech == "1") {
            colorName = "one_color";
          } else if (item.speech == "2") {
            colorName = "two_color";
          } else if (item.speech == "3") {
            colorName = "three_color";
          } else if (item.speech == "4") {
            colorName = "four_color";
          }
          return (
            <div style={{ cursor: "pointer" }}>
              <div className={colorName + " column-div"}>
                {item.speech ? item.speech : "---"}
              </div>
            </div>
          );
        },
      },
      {
        title: "Salvation",
        dataIndex: "salvation",
        key: "salvation",
        width: 100,
        render: (item) => {
          let colorName = "zero_color";
          if (item.salvation == "1") {
            colorName = "one_color";
          } else if (item.salvation == "2") {
            colorName = "two_color";
          } else if (item.salvation == "3") {
            colorName = "three_color";
          } else if (item.salvation == "4") {
            colorName = "four_color";
          }
          return (
            <div style={{ cursor: "pointer" }}>
              <div className={colorName + " column-div"}>
                {item.salvation ? item.salvation : "---"}
              </div>
            </div>
          );
        },
      },
      {
        title: "Swallowing",
        dataIndex: "swallowing",
        key: "swallowing",
        render: (item) => {
          let colorName = "zero_color";
          if (item.swallowing == "1") {
            colorName = "one_color";
          } else if (item.swallowing == "2") {
            colorName = "two_color";
          } else if (item.swallowing == "3") {
            colorName = "three_color";
          } else if (item.swallowing == "4") {
            colorName = "four_color";
          }
          return (
            <div style={{ cursor: "pointer" }}>
              <div className={colorName + " column-div"}>
                {item.swallowing ? item.swallowing : "---"}
              </div>
            </div>
          );
        },
      },
      {
        title: "Handwriting",
        dataIndex: "handwriting",
        key: "handwriting",
        width: 130,
        render: (item) => {
          let colorName = "zero_color";
          if (item.handwriting == "1") {
            colorName = "one_color";
          } else if (item.handwriting == "2") {
            colorName = "two_color";
          } else if (item.handwriting == "3") {
            colorName = "three_color";
          } else if (item.handwriting == "4") {
            colorName = "four_color";
          }
          return (
            <div style={{ cursor: "pointer" }}>
              <div className={colorName + " column-div"}>
                {item.handwriting ? item.handwriting : "---"}
              </div>
            </div>
          );
        },
      },
      {
        title: "Cutting Food",
        dataIndex: "cutting_food",
        key: "cutting_food",
        width: 140,
        render: (item) => {
          let colorName = "zero_color";
          let value = "";
          if (item.cutting_food_a) {
            value = item.cutting_food_a;
            if (item.cutting_food_a == "1") {
              colorName = "one_color";
            } else if (item.cutting_food_a == "2") {
              colorName = "two_color";
            } else if (item.cutting_food_a == "3") {
              colorName = "three_color";
            } else if (item.cutting_food_a == "4") {
              colorName = "four_color";
            }
          } else {
            value = item.cutting_food_b;
            if (item.cutting_food_b == "1") {
              colorName = "one_color";
            } else if (item.cutting_food_b == "2") {
              colorName = "two_color";
            } else if (item.cutting_food_b == "3") {
              colorName = "three_color";
            } else if (item.cutting_food_b == "4") {
              colorName = "four_color";
            }
          }
          return (
            <div style={{ cursor: "pointer" }}>
              <div className={colorName + " column-div"}>
                {value ? value : "---"}
              </div>
            </div>
          );
        },
      },
      // {
      //   title: "Cutting Food ()",
      //   dataIndex: "cutting_food_b",
      //   key: "cutting_food_b",
      //   width: 140,
      //   render: (item) => {
      //     let colorName = "zero_color";
      //     if (item.cutting_food_b == "1") {
      //       colorName = "one_color";
      //     } else if (item.cutting_food_b == "2") {
      //       colorName = "two_color";
      //     } else if (item.cutting_food_b == "3") {
      //       colorName = "three_color";
      //     } else if (item.cutting_food_b == "4") {
      //       colorName = "four_color";
      //     }
      //     return (
      //       <div style={{ cursor: "pointer" }}>
      //         <div className={colorName + " column-div"}>
      //           {item.cutting_food_b ? item.cutting_food_b : "---"}
      //         </div>
      //       </div>
      //     );
      //   },
      // },
      {
        title: "Dressing and Hygiene",
        dataIndex: "dressing_hygine",
        key: "dressing_hygine",
        width: 180,
        render: (item) => {
          let colorName = "zero_color";
          if (item.dressing_and_hygiene == "1") {
            colorName = "one_color";
          } else if (item.dressing_and_hygiene == "2") {
            colorName = "two_color";
          } else if (item.dressing_and_hygiene == "3") {
            colorName = "three_color";
          } else if (item.dressing_and_hygiene == "4") {
            colorName = "four_color";
          }
          return (
            <div style={{ cursor: "pointer" }}>
              <div className={colorName + " column-div"}>
                {item.dressing_and_hygiene ? item.dressing_and_hygiene : "---"}
              </div>
            </div>
          );
        },
      },
      {
        title: "Turning in bed",
        dataIndex: "turning_in_bed",
        key: "turning_in_bed",
        width: 140,
        render: (item) => {
          let colorName = "zero_color";
          if (item.turning_in_bed == "1") {
            colorName = "one_color";
          } else if (item.turning_in_bed == "2") {
            colorName = "two_color";
          } else if (item.turning_in_bed == "3") {
            colorName = "three_color";
          } else if (item.turning_in_bed == "4") {
            colorName = "four_color";
          }
          return (
            <div style={{ cursor: "pointer" }}>
              <div className={colorName + " column-div"}>
                {item.turning_in_bed ? item.turning_in_bed : "---"}
              </div>
            </div>
          );
        },
      },
      {
        title: "Walking",
        dataIndex: "walking",
        key: "walking",
        width: 90,
        render: (item) => {
          let colorName = "zero_color";
          if (item.walking == "1") {
            colorName = "one_color";
          } else if (item.walking == "2") {
            colorName = "two_color";
          } else if (item.walking == "3") {
            colorName = "three_color";
          } else if (item.walking == "4") {
            colorName = "four_color";
          }
          return (
            <div style={{ cursor: "pointer" }}>
              <div className={colorName + " column-div"}>
                {item.walking ? item.walking : "---"}
              </div>
            </div>
          );
        },
      },
      {
        title: "Climbing stairs",
        dataIndex: "climbing_stairs",
        key: "climbing_stairs",
        width: 130,
        render: (item) => {
          let colorName = "zero_color";
          if (item.climbing_stairs == "1") {
            colorName = "one_color";
          } else if (item.climbing_stairs == "2") {
            colorName = "two_color";
          } else if (item.climbing_stairs == "3") {
            colorName = "three_color";
          } else if (item.climbing_stairs == "4") {
            colorName = "four_color";
          }
          return (
            <div style={{ cursor: "pointer" }}>
              <div className={colorName + " column-div"}>
                {item.climbing_stairs ? item.climbing_stairs : "---"}
              </div>
            </div>
          );
        },
      },
      {
        title: "Dyspnea",
        dataIndex: "dyspnea",
        key: "dyspnea",
        width: 100,
        render: (item) => {
          let colorName = "zero_color";
          if (item.dyspnea == "1") {
            colorName = "one_color";
          } else if (item.dyspnea == "2") {
            colorName = "two_color";
          } else if (item.dyspnea == "3") {
            colorName = "three_color";
          } else if (item.dyspnea == "4") {
            colorName = "four_color";
          }
          return (
            <div style={{ cursor: "pointer" }}>
              <div className={colorName + " column-div"}>
                {item.dyspnea ? item.dyspnea : "---"}
              </div>
            </div>
          );
        },
      },
      {
        title: "Orthopnea",
        dataIndex: "orthopnea",
        key: "orthopnea",
        width: 110,
        render: (item) => {
          let colorName = "zero_color";
          if (item.orthopnea == "1") {
            colorName = "one_color";
          } else if (item.orthopnea == "2") {
            colorName = "two_color";
          } else if (item.orthopnea == "3") {
            colorName = "three_color";
          } else if (item.orthopnea == "4") {
            colorName = "four_color";
          }
          return (
            <div style={{ cursor: "pointer" }}>
              <div className={colorName + " column-div"}>
                {item.orthopnea ? item.orthopnea : "---"}
              </div>
            </div>
          );
        },
      },
      {
        title: "Respiratory insufficiency",
        dataIndex: "respiratory",
        key: "respiratory",
        width: 210,
        render: (item) => {
          let colorName = "zero_color";
          if (item.respiratory_insufficiency == "1") {
            colorName = "one_color";
          } else if (item.respiratory_insufficiency == "2") {
            colorName = "two_color";
          } else if (item.respiratory_insufficiency == "3") {
            colorName = "three_color";
          } else if (item.respiratory_insufficiency == "4") {
            colorName = "four_color";
          }
          return (
            <div style={{ cursor: "pointer" }}>
              <div className={colorName + " column-div"}>
                {item.respiratory_insufficiency
                  ? item.respiratory_insufficiency
                  : "---"}
              </div>
            </div>
          );
        },
      },
      {
        title: "Total",
        dataIndex: "total",
        key: "total",
        width: 90,
      },
    ];
    return (
      <>
        <a onClick={() => this.showDetailsModal()}>
          <i
            className="fas fa-eye"
            style={{
              color: "#000",
              fontSize: 18,
              position: "relative",
              top: 2,
            }}
          ></i>
          <span style={{ fontSize: 14, marginLeft: 10 }}>View ALSFRS-R</span>
        </a>{" "}
        {/* Start als frs modal  */}
        <Modal
          title={Strings.viewAlsfrs}
          visible={this.state.modalStatus}
          onOk={this.hideDetailsModal}
          onCancel={this.hideDetailsModal}
          width={780}
          footer={false}
        >
          <div>
            <Spin spinning={this.state.modalLoader}>
              <div className="row participant-div">
                <Table
                  dataSource={dataSource}
                  loading={this.state.loading}
                  pagination={{ pageSize: this.state.paginationNum }}
                  columns={Columns}
                  scroll={{ x: 1800 }}
                  onChange={this.handleTableChange}
                />
              </div>
            </Spin>
          </div>
        </Modal>
        {/* End als frs modal  */}
      </>
    );
  }
}
export default ViewEalsFrs;
